import { Directive, ElementRef,Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[intouchloader]'
})
export class IntouchLoader1Directive {

  private _loader:boolean = true;
  private maskDiv:any;

  constructor(private renderer: Renderer2,private el: ElementRef) { }

  

  @Input('intouchloader') set intouchLoader(value:boolean){
    if(value == undefined){
      this._loader = true;
    }else{
      this._loader = value;
    }
    
    if(this._loader){
      this.showLoader();
    }else{
      this.hideLoader();
    }
  }

  get intouchLoader():boolean{
    return this._loader;
  }



  private showLoader() {
    let element = this.el.nativeElement;
    this.maskDiv = this.renderer.createElement('div');
    this.renderer.setStyle(this.maskDiv,"width", element.style.width || element.style.minWidth);
    this.renderer.setStyle(this.maskDiv,"height", element.style.height || element.style.minHeight);
    this.renderer.setStyle(this.maskDiv,"z-index", 999999);
    this.renderer.setStyle(this.maskDiv,"background-color", "#ffffff");
    this.renderer.setStyle(this.maskDiv,"background-position", "center");
    this.renderer.setStyle(this.maskDiv,"background-repeat", "no-repeat");
    this.renderer.setStyle(this.maskDiv,"background-image", "url(http://intouchdev.mapmyindia.com/IntouchWeb/images/loader.gif)");
    this.renderer.setStyle(this.maskDiv,"opacity", .5);
    this.renderer.setStyle(this.maskDiv,"position", "absolute");
    this.renderer.setStyle(this.maskDiv,"top", 0);
    
    this.renderer.appendChild(element, this.maskDiv);
   
  }

  private hideLoader() {
    let element = this.el.nativeElement;
    // this.renderer.setStyle(element,"z-index", null);
    // this.renderer.setStyle(element,"background-color", null);
    // this.renderer.setStyle(element,"background-position", null);
    // this.renderer.setStyle(element,"background-repeat", null);
    // this.renderer.setStyle(element,"background-image", null);
    // this.renderer.setStyle(element,"opacity", null);
     this.renderer.removeChild(element,this.maskDiv);

  }
}
